class MobileMenu {
    constructor() {
        this.DOM = {
            body: document.body,
            buttonMenu: document.querySelector('.button-menu'),
            dropdownMenuItemsMobile: document.querySelectorAll('.menu-fullscreen .menu-item-has-children')
        };

        this.setEventListeners();
    }

    setEventListeners() {
        this.DOM.dropdownMenuItemsMobile.forEach((menuItem) => {
            const toggleArrow = menuItem.querySelector('.dropdown-arrow');
            toggleArrow.addEventListener('click', () => this.toggleSubMenu(menuItem));
        });
    }

    toggleSubMenu(currentMenuItem) {
        const currentIsOpen = Boolean(currentMenuItem.classList.contains('open'));

        let alreadyOpened = false;
        this.DOM.dropdownMenuItemsMobile.forEach((subMenuItem) => {
            const isOpen = Boolean(subMenuItem.classList.contains('open'));
            if (isOpen) {
                subMenuItem.classList.remove('open');
                alreadyOpened = true;
            }
        });

        document.body.classList.toggle('mobile-submenu-open', !currentIsOpen);

        setTimeout(
            () => {
                if (!currentIsOpen) {
                    currentMenuItem.classList.add('open');
                }
            },
            alreadyOpened ? 600 : 0
        );
    }
}
new MobileMenu();
